/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */
import * as References from './AiAgentService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#isMaintenanceModeEnabled
 */
export const IS_MAINTENANCE_MODE_ENABLED_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_isMaintenanceModeEnabled';
export const IS_MAINTENANCE_MODE_ENABLED_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.IsMaintenanceModeEnabledResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: IS_MAINTENANCE_MODE_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.IsMaintenanceModeEnabledResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.isMaintenanceModeEnabledRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#validateName
 */
export const VALIDATE_NAME_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_validateName';
export const VALIDATE_NAME_QUERY: RegisteredQuery<
  'result',
  References.ValidateNameRequestType,
  References.ValidateNameResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: VALIDATE_NAME_QUERY_FIELD_NAME,
  args: ['name', 'aiAgentUserId'],
  fetcher(
    request: References.ValidateNameRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ValidateNameResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.validateNameRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#createAgent
 */
export const CREATE_AGENT_MUTATION_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_createAgent';
export const CREATE_AGENT_MUTATION: RegisteredQuery<
  'result',
  References.CreateAgentRequestType,
  References.CreateAgentResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_AGENT_MUTATION_FIELD_NAME,
  args: [
    'name',
    'businessUnitId',
    'role',
    'personality',
    'agentType',
    'voice',
    'configuredLanguages',
  ],
  fetcher(
    request: References.CreateAgentRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateAgentResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.createAgentRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#updateAgentProfile
 */
export const UPDATE_AGENT_PROFILE_MUTATION_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_updateAgentProfile';
export const UPDATE_AGENT_PROFILE_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentProfileRequestType,
  References.UpdateAgentProfileResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_PROFILE_MUTATION_FIELD_NAME,
  args: [
    'name',
    'role',
    'personality',
    'avatarFileId',
    'voice',
    'configuredLanguages',
    'businessUnitId',
    'aiAgentUserId',
  ],
  fetcher(
    request: References.UpdateAgentProfileRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentProfileResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentProfileRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAgentProfileByUserId
 */
export const GET_AGENT_PROFILE_BY_USER_ID_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAgentProfileByUserId';
export const GET_AGENT_PROFILE_BY_USER_ID_QUERY: RegisteredQuery<
  'result',
  References.GetAgentProfileByUserIdRequestType,
  References.GetAgentProfileByUserIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_PROFILE_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(
    request: References.GetAgentProfileByUserIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentProfileByUserIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentProfileByUserIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAgentByUserId
 */
export const GET_AGENT_BY_USER_ID_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAgentByUserId';
export const GET_AGENT_BY_USER_ID_QUERY: RegisteredQuery<
  'result',
  References.GetAgentByUserIdRequestType,
  References.GetAgentByUserIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(
    request: References.GetAgentByUserIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentByUserIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentByUserIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAgentTone
 */
export const GET_AGENT_TONE_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAgentTone';
export const GET_AGENT_TONE_QUERY: RegisteredQuery<
  'result',
  References.GetAgentToneRequestType,
  References.GetAgentToneResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_TONE_QUERY_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(
    request: References.GetAgentToneRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentToneResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getAgentToneRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentOrThrowIfMultiple
 */
export const GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentOrThrowIfMultiple';
export const GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAiAgentOrThrowIfMultipleResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAiAgentOrThrowIfMultipleResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAiAgentOrThrowIfMultipleRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentsForPortal
 */
export const GET_AI_AGENTS_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentsForPortal';
export const GET_AI_AGENTS_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  References.GetAiAgentsForPortalRequestType,
  References.GetAiAgentsForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AI_AGENTS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['offset', 'deletedFilter', 'visibilityFilter', 'pageLength'],
  fetcher(
    request: References.GetAiAgentsForPortalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAiAgentsForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAiAgentsForPortalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentProfilesForPortal
 */
export const GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentProfilesForPortal';
export const GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  References.GetAiAgentProfilesForPortalRequestType,
  References.GetAiAgentProfilesForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(
    request: References.GetAiAgentProfilesForPortalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAiAgentProfilesForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAiAgentProfilesForPortalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getHydratedAiAgentDataForPortal
 */
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getHydratedAiAgentDataForPortal';
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetHydratedAiAgentDataForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHydratedAiAgentDataForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHydratedAiAgentDataForPortalRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getHydratedAiAgentDataForPortalV2
 */
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getHydratedAiAgentDataForPortalV2';
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetHydratedAiAgentDataForPortalV2ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHydratedAiAgentDataForPortalV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHydratedAiAgentDataForPortalV2Rpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#deleteAgent
 */
export const DELETE_AGENT_MUTATION_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_deleteAgent';
export const DELETE_AGENT_MUTATION: RegisteredQuery<
  'result',
  References.DeleteAgentRequestType,
  References.DeleteAgentResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_AGENT_MUTATION_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(
    request: References.DeleteAgentRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteAgentResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.deleteAgentRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#restoreAgent
 */
export const RESTORE_AGENT_MUTATION_FIELD_NAME =
  'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_restoreAgent';
export const RESTORE_AGENT_MUTATION: RegisteredQuery<
  'result',
  References.RestoreAgentRequestType,
  References.RestoreAgentResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: RESTORE_AGENT_MUTATION_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(
    request: References.RestoreAgentRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RestoreAgentResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.restoreAgentRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
